import { Investment, Building, Floors, Floor } from 'browser/schemes';

// Building imports
import map1 from './maps/3d/map1';

import { ReactComponent as p0 } from './maps/floors/p0.svg';
import { ReactComponent as p1 } from './maps/floors/p1.svg';
import { ReactComponent as p2 } from './maps/floors/p2.svg';

const floors = new Floors({
  streets: {
    top: '',
    bottom: '',
    left: '',
    right: '',
  },
  windroseRotation: 0,
  list: [
    new Floor({
      level: 0,
      map: p0,
      backgroundImage: require('./assets/floors/p0.png').default,
    }),
    new Floor({
      level: 1,
      map: p1,
      backgroundImage: require('./assets/floors/p1.png').default,
    }),
    new Floor({
      level: 2,
      map: p2,
      backgroundImage: require('./assets/floors/p2.png').default,
    }),
  ],
});

const buildingA = new Building({
  name: 'M',
  active: true,
  spritespin: {
    framesURL: {
      day: require('./assets/building.jpg').default,
    },
    framesPerRow: 1,
    frames: 1,
    breakpoints: [0],
    frameTime: 50,
    maps: [map1],
    reverse: false,
    windroseInitialRotation: 0,
  },
  floors,
});

const buildings = new Map();
buildings.set(buildingA.id, buildingA);

const investment = new Investment({
  investmentName: 'Yacht Apartment',
  mailerURL: 'https://hosting2108408.online.pro/mailer/mailer.php',
  flatsURL: 'https://hosting2108408.online.pro/api/flats/',
  buildings,
});

export default investment;
